import React, { Component } from "react";
import { deletestore, getTOWithStatus, getstores } from "../Path/Path";
import { withRouter } from "../components/withRouter";
import { toast } from 'react-toastify';
import { PaginatedItems } from "../components/Paginated";
import { Autocomplete, TextField } from "@mui/material";
import Loader from "../components/Loader";
import { DesktopDatePicker } from "@mui/x-date-pickers";
class TOCreated extends Component {
    state = {


        storename: "",
        storecountry: "",
        storecompany: "",
        tableFilter: [],
        itemsPerPage: 10,
        loading: false,


        allPOs: [],
        allPOsFilter: [],
        poPaginated: null,
        createdAt: null,
        storedata: [],
        selectedSource: "",
        selectedDestination: "",
        enteredTO: ""
    }
    componentDidMount() {
        this.getTO()
    }
    handler = () => {
        this.props.history("/addstore")
    }
    formatDate = (date) => {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
        // return console.log([year, month, day].join('-'))
    }

    getTO = async (page = 1, date = "", source = "", po_number = "", destination = "") => {
        this.setState({ loading: true })
        const userinfo = await getstores();
        this.setState({ storedata: userinfo, })
        const resp = await getTOWithStatus(page, date, source, po_number, destination);
        if (resp.success) {
            this.setState({ allPOs: resp?.data, allPOsFilter: resp?.data, poPaginated: resp })
        }

        this.setState({ loading: false })
    }
    deleteHandler = async (myID) => {

        try {

            await deletestore(myID);
            this.getTO();
            toast.success("Store delete successfully")
        } catch (err) {
            toast.warn(err.message)

        }
    }
    editHandler = (item) => {

        this.props.history("/addstore", { state: { item } })
    }
    searchHandler = () => {
        let date = this.state.createdAt ? `&createdAt[gte]=${this.formatDate(this.state.createdAt)}` : ""
        let source = this.state.selectedSource ? `&source=${this.state.selectedSource}` : ""
        let destination = this.state.selectedDestination ? `&destination=${this.state.selectedDestination}` : ""
        let ASN = this.state.enteredTO ? `&ASN=${this.state.enteredTO}` : ""

        this.getTO(this.state.poPaginated?.page, date, source, ASN, destination)
    }
    render() {
        const headers = [

            "ASN",
            "toCreattionType",
            "source",
            "destination",
            "status",
            "QTY",
            "createdAt",

        ]

        const colNames = [

            "ASN",
            "toCreattionType",
            "source",
            "destination",
            "status",
            "created QTY",
            "createdAt",


        ]

        return (
            <>
                <Loader loading={this.state.loading} />
                <div className="dashboard-main">
                    <div className="dashboard-top">
                        <div> <p className="stock-count" style={{ fontSize: '25px', margin: 0 }}>TO (Created)</p>
                            <h1 style={{ color: 'black', fontSize: '15px' }}>{new Date().toLocaleString('hi-IN')} </h1>
                        </div>
                        {/* <button className="run-btn"><p className="add-text" onClick={() => this.handler()}>Add Store</p></button> */}
                    </div>
                    <div className="store-bottom">
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between", width: "720px" }}>
                            {/* <p className="filter-text">Filters</p> */}
                            <DesktopDatePicker
                                label="Created At"
                                clearable
                                showTodayButton
                                inputFormat="YYYY/MM/DD"
                                size={'small'}
                                value={this.state.createdAt}
                                onChange={(data) => { this.setState({ createdAt: data }); console.log(data, "data") }}
                                renderInput={(params) => <TextField sx={{ width: 170 }} size={'small'} {...params} />}
                            />
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                size={'small'}
                                options={this.state.storedata?.map((item => item?.Warehouse)).reduce((noDupArr, entry) => {
                                    if (noDupArr?.includes(entry)) {
                                        return noDupArr;
                                    } else {
                                        return [...noDupArr, entry];
                                    }
                                }, []).filter((item => item !== null))}
                                onInputChange={(e) => this.setState({selectedSource:  e.target.value === 0 || e.target.value === undefined ? '' : e.target.value})}
                                onChange={(e, v) => this.setState({ selectedSource: v === null ? '' : v })}
                                sx={{ width: 235 }}
                                renderInput={(params) => <TextField
                                    {...params} label="Source" />}
                            />
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                size={'small'}
                                options={this.state.storedata?.map((item => item?.Warehouse)).reduce((noDupArr, entry) => {
                                    if (noDupArr?.includes(entry)) {
                                        return noDupArr;
                                    } else {
                                        return [...noDupArr, entry];
                                    }
                                }, []).filter((item => item !== null))}
                                onInputChange={(e) => this.setState({selectedDestination:  e.target.value === 0 || e.target.value === undefined ? '' : e.target.value})}
                                onChange={(e, v) => this.setState({ selectedDestination: v === null ? '' : v })}
                                sx={{ width: 235 }}
                                renderInput={(params) => <TextField
                                    {...params} label="Destination" />}
                            />
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                freeSolo={true}
                                size={'small'}

                                options={[]}
                                onInputChange={(e) => this.setState({enteredTO:  e.target.value === 0 || e.target.value === undefined ? '' : e.target.value})}
                                // onChange={(e, v) => setinvoiceNumberVal(v === null || v === undefined ? '' : v)}
                                sx={{ width: 200 }}
                                renderInput={(params) => <TextField
                                    onChange={e => this.setState({ enteredTO: e.target.value })}
                                    value={this.state.enteredTO}
                                    {...params} label="to_number" />}
                            />
                        </div>



                        <button className="run-btn" onClick={() => this.searchHandler()}><p className="run-text">Run</p></button>








                    </div>
                    <div style={{ paddingTop: "2%" }}>
                        <PaginatedItems navigation={"/TOCreatedDetail"} headers={headers} getData={(pageNumber) => this.getTO(pageNumber)} pageCountNew={this.state.poPaginated?.next + this.state.poPaginated?.previous + 1} colNames={colNames} itemsPerPage={this.state.itemsPerPage} data={this.state.allPOsFilter} />
                    </div>
                </div>
            </>

        )
    }
}
export default withRouter(TOCreated);
